module.exports = __webpack_public_path__ + "static/media/Initial-Setup.90300406.png";